import { AsyncPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { I18nModule, provideConfig } from '@spartacus/core';

import { DpSocialComponent } from './social.component';

@NgModule({
  imports: [I18nModule, AsyncPipe, MatIconModule],
  providers: [
    provideConfig({
      cmsComponents: {
        DpSocialMediaComponent: {
          component: DpSocialComponent,
        },
      },
    }),
  ],
  declarations: [DpSocialComponent],
  exports: [DpSocialComponent],
})
export class DpSocialModule {}
